import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, Subscription, debounceTime, takeUntil } from 'rxjs';
import { DeleteSupplier$Params } from 'src/api/generated/fn/supplier/delete-supplier';
import { GetAllSuppliers$Params } from 'src/api/generated/fn/supplier/get-all-suppliers';
import { SupplierDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Suppliers/supplier-dto';
import { SupplierService } from 'src/api/generated/services';
import { AddOrEditSupplierComponent } from './add-or-edit-supplier/add-or-edit-supplier.component';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';

@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.component.html',
  styleUrls: ['./supplier.component.scss']
})
export class SupplierComponent implements OnInit, OnDestroy {

  public unsubscribe: Subject<void> = new Subject<void>();
  public suppliers: Array<SupplierDto>
  public venueId: string;
  public searchTerm: string = "";
  searchDebouncer = new Subject<void>();
  RELOAD_DEBOUNCE_TIME = 500;
  venueIdUpdateSubscription: Subscription;
  loading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    public currentVenueHelper: CurrentVenueHelperService,
    private router: Router,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    private supplierService: SupplierService,
  ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
      }
    });
    this.getSuppliers();
    this.searchDebouncer.pipe(
      debounceTime(this.RELOAD_DEBOUNCE_TIME)
    ).subscribe(_ => this.getSuppliers());
  }

  getSuppliers() {
    this.loading = true;
    var params: GetAllSuppliers$Params = {} as GetAllSuppliers$Params;
    params.searchTerm = this.searchTerm;
    params.isRemoved = false;
    this.supplierService.getAllSuppliers(params)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.suppliers = response.suppliers ? response.suppliers : [];          
          this.loading = false;
        },
        error: errorResponse => {
        }
      });
  }

  newSupplier() {
    const ref = this.dialogService.open(AddOrEditSupplierComponent, {
      width: '372px',
      showHeader: false,
      closeOnEscape: false,
    });
    ref.onClose.subscribe((item: any) => {
      this.getSuppliers();
    });
  }
  editSupplier(supplier: SupplierDto) {
    const ref = this.dialogService.open(AddOrEditSupplierComponent, {
      width: '372px',
      showHeader: false,
      closeOnEscape: false,
      data: {
        item: supplier
      }
    });
    ref.onClose.subscribe((item: any) => {
      this.getSuppliers();
    });
  }
  deleteSupplier(supplier: SupplierDto) {
    this.confirmationService.confirm({
      header: this.translate.instant('SUPPLIERS.DELETE_SUPPLIER_TITLE') + "?",
      message: this.translate.instant('SUPPLIERS.DELETE_SUPPLIER_TEXT') + supplier.name + " ?",
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      defaultFocus: "reject",
      closeOnEscape: false,
      acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn destructive-btn',
      rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
      accept: () => {
        var params: DeleteSupplier$Params = {} as DeleteSupplier$Params;
        if (supplier.id) {
          params.supplierId = supplier.id;
        }
        this.supplierService.deleteSupplier(params)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: (response) => {
              this.getSuppliers()
            },
            error: errorResponse => {
            }
          });
      }
    });
  }
  addPurchaseOrder(supplier: SupplierDto) {
    this.router.navigate([this.venueId, "supplier", supplier.id, "new-purchase-order"]);
  }
  search(){
    this.loading = true; 
    this.searchDebouncer.next();
  }
  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }
}
